<template>
  <div class="widget-wrapper">
    <!--TAMS-->
    <data-table ref="gpnSslVpnUserList"
                style="height: 100%"
                class="bs bs-data-table bs-data-table-slim analysis-panel-datatable"
                :data="widgetData"
                :fields="dataTableColumns"
                :resize-mode="'overflow'"
                :virtual-scrolling="false"
    />
    <!--<data-table ref="gpnSslVpnUserList"-->
                <!--class="bs bs-data-table bs-data-table-slim"-->
                <!--:data="widgetData"-->
                <!--:height="dataTableHeight"-->
                <!--:fields="dataTableColumns"-->
                <!--:resize-mode="'overflow'"-->
                <!--:virtual-scrolling="isMaximumWidget ? false : true"-->
    <!--/>-->
  </div>
</template>

<script>
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'

  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'

  // 스토어 헬퍼 객체
  const {mapGetters} = createNamespacedHelpers('common/common/')
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetSslVpnUserList',
    components: {},
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 3,
        title: 'widgetSslVpnUserList',
        isLock: false,
        isMove: true,
        // isSync: true, // TAMS 미사용
        isResize: false,
        isRefresh: true, // TAMS
        eventBus: true, // TAMS
        deviceType: [20],
        widgetData: [],
        // timerValue: 10000,
        // timerObject: void 0, // TAMS 미사용
        // lastEndTime: '', // TAMS 미사용
        currentSelect: {}
        // dataTableHeight: 226 // TAMS 미사용
      }
    },
    computed: {
      ...mapGetters([
        'getDeviceTime'
      ]),
      dataTableColumns () {
        return [
          // TAMS
          {
            name: 'mach_name',
            align: 'left',
            title: this.$t('an.mach_id'),
            sorting: false
          },
          {
            name: 'time',
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_connTime'),
            sorting: false
          },
          {
            name: 'user_id',
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_userId'),
            sorting: false
          },
          {
            name: 'src_ip',
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_remoteIp'),
            sorting: false
          },
          {
            name: 'rent_ip',
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_leaseIp'),
            sorting: false
          },
          {
            name: 'group_name',
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_groupName'),
            sorting: false
          },
          {
            name: 'auth_policy_name',
            width: 150,
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_authPolicyName'),
            sorting: false
          },
          {
            name: 'auth_type',
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_authType'),
            sorting: false
          },
          {
            name: 'os_type',
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_osType'),
            sorting: false
          },
          {
            name: 'connect_uri',
            width: 150,
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_connURI'),
            sorting: false
          },
          {
            name: 'status',
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_accStatus'),
            sorting: false
          },
          {
            name: 'failure_cnt',
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_failCount'),
            sorting: false
          },
          {
            name: 'auth_status',
            width: 150,
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_authStatus'),
            sorting: false
          },
          {
            name: 'reason',
            align: 'left',
            title: this.$t('dash.widgetSslVpnUserList_field_reason'),
            sorting: false
          }
        ]
      },
      preExecTask () {
        const dataTable = this.$refs.gpnSslVpnUserList
        return function () {
          dataTable.destroy()
        }
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {},
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 데이터 테이블 초기화
      this.$refs.gpnSslVpnUserList.destroy()

      // 모델 초기화
      this.widgetData = []
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      async getWidgetContentsData (init = false, extraParams = null) {
        const contentsOptions = {
          topN: 50,
          widgetType: 'ssl_vpn_user_login_log'
        }

        // TAMS, 해당 위젯 실시간성격이 아닌 시간 range에 따라 새로고침되도록 형상 변경 (2019-06-07)
        // /*
        //   - 10초 데이터 초기화 시 (실시간 추이 데이터)
        //     [현재 장비시간의 -30초 ~ 1분 이전] 데이터 호출 (TAMS 수정됨)
        // */
        // // 실시간 위젯은 위젯 데이터를 30초를 뺀 시간을 기준으로 한다. (Ex. 14:05:37초일 경우 기본 계산 시간은 14:05:07초)
        // const calcBaseTime = Moment(this.getDeviceTime).subtract(30, 'seconds')
        //
        // // 계산된 시간에서 1초 단위를 초기화. (14:05:00)
        // const endTime = calcBaseTime.seconds(this.floorSecondTime(calcBaseTime.seconds()))
        //
        // // 계산된 endTime에서 10초 빼기. (14:04:50)
        // // const startTime = _.cloneDeep(endTime).subtract(10, 'seconds')
        // // TAMS - 계산된 endTime에서 1분 빼기. (14:04:00)
        // const startTime = _.cloneDeep(endTime).subtract(1, 'minutes')
        //
        // // endTime에서 1초 빼기 (14:04:59)
        // contentsOptions.eTime = endTime.subtract(1, 'seconds').format('YYYY-MM-DD HH:mm:ss')
        //
        // // startTime 추가 (14:04:00 ~ 14:04:59로 최초 요청)
        // contentsOptions.sTime = startTime.format('YYYY-MM-DD HH:mm:ss')

        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          // 위젯 데이터 초기화
          this.widgetData = []
        }

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams && extraParams.machId) {
          contentsOptions.machId = extraParams.machId
        }

        // API 조회
        // const {code, eTime, result} = await this.getWidgetData(contentsOptions)
        const {code, result} = await this.getWidgetData(contentsOptions)

        // this.lastEndTime = eTime

        // Series 데이터 구성
        if (code === 'ok') {
          // TAMS
          this.widgetData = _.get(result, ['result'], []) // result.result
        } else {
          this.widgetData = [] // TAMS
        }

        // Progress 출력 여부
        this.showProgress(false)
      },
      /*
        이름: onResizeContentsFromWidget
        설명: 리사이즈 이벤트가 발생하면, 데이터 테이블의 높이를 수정한다. (TAMS 미사용)
      */
      onResizeContentsFromWidget () {
        const newHeight = this.$el.clientHeight - 24

        if (this.dataTableHeight !== newHeight) {
          this.dataTableHeight = newHeight
        }
      }
    },
    watch: {
      // /*
      //   이름: widgetData
      //   설명: 원본 위젯 데이터가 변경되면 최대화 팝업 모델을 업데이트한다.
      // */
      // widgetData (widgetData) {
      //   // 최대화 위젯이 아니고, isSync를 사용하는 경우
      //   if (!this.isMaximumWidget && this.isSync) {
      //     // 데이터가 들어오면 최대화 팝업에 데이터 전달
      //     Bus.$emit(`${this.$options.name}_sync_maximumpopup`, widgetData)
      //   }
      // }
    }
  }
</script>

<style scoped>
</style>
